/**
 * Directive: search
 */
angular.module('acme.common.directive.search', [])
.directive('search', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/search/search.tpl.html',
      scope: {
        model: '='
      },
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.search = {
          model: ''
        };

      }]

    };

}]);